var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAm4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.2,
    height: 23.112,
    viewBox: "0 0 23.2 23.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5495",
    "data-name": "Group 5495",
    transform: "translate(0.538 0.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1610",
    "data-name": "Rectangle 1610",
    width: 22,
    height: 19,
    transform: "translate(0.063 2.912)",
    fill: "none",
    stroke: "#939299",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    x2: 22,
    transform: "translate(0.063 7.912)",
    fill: "none",
    stroke: "#939299",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M17.863,8.513H12L12.838,6h4.188Z",
    transform: "translate(-9.401 -6)",
    fill: "none",
    stroke: "#939299",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M43.863,8.513H38L38.838,6h4.188Z",
    transform: "translate(-24.512 -6)",
    fill: "none",
    stroke: "#939299",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1611",
    "data-name": "Rectangle 1611",
    width: 16,
    height: 10,
    transform: "translate(3.063 7.912)",
    fill: "none",
    stroke: "#939299",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    x2: 8,
    transform: "translate(7.063 10.912)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    transform: "translate(3.92 5.227)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    transform: "translate(9.147 5.227)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    transform: "translate(18.729 5.227)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    transform: "translate(13.502 5.227)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAm4);
export default __webpack_public_path__ + "static/media/am4.ab6ee8a0c548b2a5deda971958062732.svg";
export { ForwardRef as ReactComponent };